import React, {useState} from 'react';
import { useNavigate } from 'react-router-dom';

import { Link } from 'react-router-dom';
import './body.css';
import { FaUsers, FaChalkboardTeacher, FaBalanceScale, FaLightbulb } from "react-icons/fa";
import { db } from '../../Components/FirebaseComp/firebase';
import { collection, addDoc } from "firebase/firestore";




function JoinUsForm() {

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        profession: '',
        membershipType: 'basic',
        agreeToTerms: false
      });
    
      const [submitted, setSubmitted] = useState(false);
      const [loading, setLoading] = useState(false);
      const navigate = useNavigate();
    
      const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
          ...prev,
          [name]: type === 'checkbox' ? checked : value
        }));
      };
    
      const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        
        try {
          await addDoc(collection(db, 'joinus'), {
            ...formData,
            timestamp: new Date()
          });
          setSubmitted(true);
          alert('Your membership application has been submitted successfully!');
          setTimeout(() => {
            navigate('/');
          }, 3000);
        } catch (error) {
          console.error("Error adding document: ", error);
          alert('There was an error submitting your application. Please try again.');
        } finally {
          setLoading(false);
        }
      };
    
      if (submitted) {
        return (
          <div className="success-message">
            <h2>Thank You for Joining!</h2>
            <p>Your membership application has been received.</p>
          </div>
        );
      }

      
      
  return (
    <div className="join-form-container">
    <div className="form-overlay"></div>
    <div className="form-content">
      <div className="form-header">
        <h2>Join Now: Become a Member</h2>
        <p>As an CEOA member, you'll be supporting advocacy efforts that help advance and protect the profession. Plus, you'll get access to exclusive continuing education programs and clinical resources.</p>
      </div>

      <form onSubmit={handleSubmit} className="join-form">
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="name">Full Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label htmlFor="profession">Profession</label>
            <input
              type="text"
              id="profession"
              name="profession"
              value={formData.profession}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Membership Type</label>
            <div className="radio-group">
              <label>
                <input
                  type="radio"
                  name="membershipType"
                  value="basic"
                  checked={formData.membershipType === 'basic'}
                  onChange={handleChange}
                />
                Basic Membership
              </label>
              <label>
                <input
                  type="radio"
                  name="membershipType"
                  value="premium"
                  checked={formData.membershipType === 'premium'}
                  onChange={handleChange}
                />
                Premium Membership
              </label>
            </div>
          </div>
        </div>

        <div className="form-group checkbox-group">
          <div className="checkbox-container">
            <input
              type="checkbox"
              id="agreeToTerms"
              name="agreeToTerms"
              checked={formData.agreeToTerms}
              onChange={handleChange}
              required
            />
            <label htmlFor="agreeToTerms">I agree to the terms and conditions</label>
          </div>
        </div>

        <button type="submit" className="submit-btn" disabled={loading}>
          {loading ? 'Processing...' : 'JOIN THE CEOA'}
        </button>
      </form>
    </div>
  </div>
  )
}

export default JoinUsForm